export default __webpack_public_path__ + "static/media/image-2.67c6ce06.png";